angular.module('impactx.toolbar').directive('ixToolbarButton', function (ToolbarService) {
    return {
        scope: {
            label: "=",
            linkFunction: "&",
            stateFunction: "=",
            action: "&",
            type: "=",
            params: "=",
            process: "=",
            trns: "=",
            additionalFields: "=",
            printExcel: "&",
            icon: '@',
            iconClass: '@',
            tooltip: '@',
            labelFunction: "&"
        },
        restrict: 'E',
        templateUrl: 'shared/toolbar/templates/toolbar.button.tmpl.html',
        link: function (scope) {
            scope.pending = false;
            scope.handleAction = function ($event, trns, additionalFields) {
                if (scope.pending) return;
                var result = scope.action({ event: $event, trns: trns, additionalFields: additionalFields });
                if (result && typeof result.then === 'function') {
                    scope.pending = true;
                    result.then(function () {
                        scope.pending = false;
                    }, function () {
                        scope.pending = false;
                    });
                    return result;
                }
            };

            var result = 'shared/toolbar/templates/toolbar.actionbutton.tmpl.html';
            if (scope.type == 'dialogaction') {
                result = 'shared/toolbar/templates/toolbar.dialogactionbutton.tmpl.html';
            }
            if (scope.type == 'print') {
                result = 'shared/toolbar/templates/toolbar.printbutton.tmpl.html';
            }
            if (scope.type == 'download') {
                result = 'shared/toolbar/templates/toolbar.downloadbutton.tmpl.html';
            }
            if (scope.type == 'link') {
                result = 'shared/toolbar/templates/toolbar.linkbutton.tmpl.html';
            }
            if (scope.type == 'validation') {
                result = 'shared/toolbar/templates/toolbar.validationbutton.tmpl.html';
            }
            if (scope.type == 'icon') {
                result = 'shared/toolbar/templates/toolbar.iconbutton.tmpl.html';
            }
            // Angular-Erweitertung (Katalog-Editor)
            if (scope.type === 'filterlist') {
                result = 'shared/toolbar/templates/toolbar.filtersidebarbutton.tmpl.html';
            }
            // Angular-Erweitertung (Katalog-Editor)
            if (scope.type === 'filtersave') {
                result = 'shared/toolbar/templates/toolbar.filtersavesidebarbutton.tmpl.html';
            }
            scope.template = result;
        }
    };
});